var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"image",class:{'lazy-loading': !_vm.showImage},attrs:{"src":"","data-src":_vm.imageSource,"alt":_vm.altText},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }